module.exports = __webpack_public_path__ + "media/images/logo-compleet3-ef9f650026064a9686f3d961b52cc6d9.svg";